// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","btnGroup":"DesktopAuthButtons_btnGroup__OQUd9","btn":"DesktopAuthButtons_btn__a9jdD","minimal":"DesktopAuthButtons_minimal__7kje7"};